import { Steps } from 'antd';
import { FileDoneOutlined, FileSyncOutlined, SolutionOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { offer_step } from 'constant/static';

/**
 * Her sekmenin açılabildiği en düşük `offer.step` değeri; sekme sırası BE adımlarıyla bire bir örtüşmez.
 * Sipariş ve Telif, CONTENT adımında da açılır (useHandleProcess bu adımda o sekmeyi seçer).
 */
const MIN_STEP_TO_OPEN = [offer_step.OFFER, offer_step.CONTENT, offer_step.POST_ORDER, offer_step.PUBLISH];

const ArticleProcess = ({ process, offerStep, setProcess }) => {
  const steps = ['detection', 'order', 'afterCopyright', 'publish'];

  function stepStatus(step) {
    if (step === 0 && offerStep === 0) {
      return { name: 'process', icon: <FileSyncOutlined /> };
    }
    if (step + 2 < offerStep) {
      return { name: 'finished', icon: <FileDoneOutlined /> };
    } else if (step === 0 && offerStep === 1) {
      return { name: 'process', icon: <FileSyncOutlined /> };
    } else if (step + 2 > offerStep) {
      return { name: 'wait', icon: <SolutionOutlined /> };
    }

    return { name: 'process', icon: <FileSyncOutlined /> };
  }

  const items = steps.map((step, idx) => ({
    key: step,
    status: stepStatus(idx).name,
    title: (
      <span className={classNames({ 'gx-text-underline': process - 1 === idx })}>
        <FormattedMessage id={`article.process.${step}`} />
      </span>
    ),
    icon: stepStatus(idx).icon,
    className: classNames({
      'completed-step': stepStatus(idx).name === 'finished',
      clickable: offerStep >= MIN_STEP_TO_OPEN[idx],
    }),
    onClick: () => offerStep >= MIN_STEP_TO_OPEN[idx] && setProcess(idx + 1),
  }));

  return (
    <Steps
      className="gx-mt-3 gx-mb-5"
      labelPlacement="vertical"
      items={items}
      responsive
    />
  );
};
export default ArticleProcess;
